import React, { memo } from 'react';
import styles from './styles.module.css';
import { Modal } from 'antd';

/**
 * 確認モーダルの実装
 */
interface FujiModalProps {
    title?: React.ReactNode | null;
    body?: React.ReactNode | null;
    txtSubmit?: string | null;
    txtCancel?: string;
    isOpen: boolean;
    onSubmit?: () => void;
    onCancel?: () => void;
}

const FujiModal = memo(({ title, body, txtSubmit, txtCancel, isOpen, onSubmit, onCancel }: FujiModalProps) => {
    /**
     * onSubmitを実行してモーダルを閉じる
     */
    const onSubmitModal = (event: React.MouseEvent<HTMLButtonElement>) => {
        event.stopPropagation();
        try {
            if (typeof onSubmit !== 'function') throw new Error('onSubmit is not function');
            onSubmit();
        } catch {}
    };

    /**
     * モーダルを閉じる
     */
    const onCloseModal = (event: React.MouseEvent<HTMLButtonElement>) => {
        event.stopPropagation();
        try {
            if (typeof onCancel !== 'function') throw new Error('onCancel is not function');
            onCancel();
        } catch {}
    };

    return (
        <Modal
            className={styles.fujiModal}
            destroyOnHidden
            maskClosable={false}
            closable={false}
            title={title}
            width={280}
            open={isOpen}
            centered
            onCancel={(event) => onCloseModal(event)}
            footer={null}
        >
            {body}
            <div className={styles.fujiModalFooter}>
                {!!txtCancel && !!txtSubmit ? (
                    <React.Fragment>
                        <button className={styles.btnBack} key="back" onClick={(event) => onCloseModal(event)}>
                            {txtCancel}
                        </button>
                        <div className={styles.boderVertical} />
                        <button
                            className={styles.btnSubmit}
                            key="submit"
                            type="submit"
                            onClick={(event) => onSubmitModal(event)}
                        >
                            {txtSubmit}
                        </button>
                    </React.Fragment>
                ) : txtSubmit ? (
                    <button
                        className={styles.btnSubmit}
                        key="submit"
                        type="submit"
                        onClick={(event) => onSubmitModal(event)}
                    >
                        {txtSubmit}
                    </button>
                ) : (
                    <button className={styles.btnBack} key="back" onClick={(event) => onCloseModal(event)}>
                        {txtCancel}
                    </button>
                )}
            </div>
        </Modal>
    );
});

export default FujiModal;
